import { Observable } from 'rxjs';
import { IDwProgram } from '../program-info/interface/program.interface';
import { DwOperationInfoListService } from '../program-info/operation-info-list.service';
import { DwIamPermissionInfoService } from './iam-permission-info.service';
var DwIamTabRouteConfigService = /** @class */ (function () {
    function DwIamTabRouteConfigService(iamPermissionInfo, operationInfoListService, tabRouteConfigJson) {
        this.iamPermissionInfo = iamPermissionInfo;
        this.operationInfoListService = operationInfoListService;
        this.tabRouteConfigJson = tabRouteConfigJson;
    }
    DwIamTabRouteConfigService.prototype.newConfig = function (info, option) {
        var _option = {
            id: '',
            menuId: '',
            name: '',
            routerLink: '',
            type: ''
        };
        if (info) {
            _option = Object.assign(_option, option);
            _option.routerLink = info.routerLink;
            _option.type = info.type;
        }
        return _option;
    };
    Object.defineProperty(DwIamTabRouteConfigService.prototype, "routeConfigInfos$", {
        get: function () {
            var _this = this;
            return Observable.create(function (observer) {
                var operationSubc = _this.operationInfoListService.operationListMap$.subscribe(function (res) {
                    if (res !== null) {
                        var operationListMap_1 = Object.assign({}, res);
                        var permissionSubc = _this.iamPermissionInfo.authorizedList$.subscribe(function (auths) {
                            var authorizedList = Object.assign({}, auths);
                            var tabRouteConfig = [];
                            _this.tabRouteConfigJson.forEach(function (tabRouteConfigJsonItem) {
                                var id = tabRouteConfigJsonItem.id;
                                var check = false;
                                if (id === 'home') {
                                    check = true;
                                }
                                else if (authorizedList[id]) {
                                    check = true;
                                }
                                if (check) {
                                    var newConfig = _this.newConfig(operationListMap_1[id], tabRouteConfigJsonItem);
                                    if (newConfig.id !== '') {
                                        tabRouteConfig.push(newConfig);
                                    }
                                }
                                else if (operationListMap_1[id]) {
                                    var newConfig = _this.newConfig(operationListMap_1[id], tabRouteConfigJsonItem);
                                    if (newConfig.id !== '') {
                                        if (newConfig.type === 'fineReport' || newConfig.type === 'externalUrl') {
                                            if (newConfig.type === 'fineReport') {
                                                newConfig.id = operationListMap_1[id].code;
                                            }
                                            if (newConfig.type === 'externalUrl') {
                                                newConfig.menuId = newConfig.id;
                                            }
                                            tabRouteConfig.push(newConfig);
                                        }
                                    }
                                }
                            });
                            observer.next({
                                'tabRouteConfig': tabRouteConfig,
                                'operationListMap': operationListMap_1
                            });
                            observer.complete();
                            if (operationSubc) {
                                operationSubc.unsubscribe();
                            }
                        }, function (error) { return console.log(error); });
                        if (permissionSubc) {
                            permissionSubc.unsubscribe();
                        }
                    }
                });
            });
            // return this.operationInfoListService.operationListMap$.pipe(
            //   switchMap(
            //     (operationListMapResp: IDwOperationMap) => {
            //       return this.iamPermissionInfo.authorizedList$;
            //     },
            //     (operationListMapResp: IDwOperationMap, authorizedListResp: IDwAuthorizedList) => {
            //       const tabRouteConfig: IDwRouteInfo[] = [];
            //       let operationListMap = {};
            //       if (operationListMapResp !== null) {
            //         operationListMap = Object.assign({}, operationListMapResp);
            //         const authorizedList = Object.assign({}, authorizedListResp);
            //         this.tabRouteConfigJson.forEach(
            //           (tabRouteConfigJsonItem: IDwRouteInfo) => {
            //             const id = tabRouteConfigJsonItem.id;
            //             let check = false;
            //             if (id === 'home') {
            //               check = true;
            //             } else if (authorizedList[id]) {
            //               check = true;
            //             }
            //             if (check) {
            //               const newConfig: IDwRouteInfo = this.newConfig(operationListMap[id], tabRouteConfigJsonItem);
            //               if (newConfig.id !== '') {
            //                 tabRouteConfig.push(newConfig);
            //               }
            //             } else if (operationListMap[id]) {
            //               const newConfig: IDwRouteInfo = this.newConfig(operationListMap[id], tabRouteConfigJsonItem);
            //               if (newConfig.id !== '') {
            //                 if (newConfig.type === 'fineReport') {
            //                   newConfig.id = operationListMap[id].code;
            //                 }
            //                 if (newConfig.type === 'externalUrl') {
            //                   newConfig.menuId = newConfig.id;
            //                 }
            //                 tabRouteConfig.push(newConfig);
            //               }
            //             }
            //           });
            //       }
            //       return {
            //         'tabRouteConfig': tabRouteConfig,
            //         'operationListMap': operationListMap
            //       };
            //     }
            //   ),
            //   first()
            // );
        },
        enumerable: true,
        configurable: true
    });
    return DwIamTabRouteConfigService;
}());
export { DwIamTabRouteConfigService };
